import React, { Component } from "react";
import { hot } from "react-hot-loader";
import { Button, Icon } from "antd";
import UpgradeButton from "../saas/UpgradeButton";
import { Link } from "react-router-dom";

function ReusableStepPromo() {
  return (
    <div
      className="upgrade-modal"
      style={{
        textAlign: "center",
        marginTop: "20px",
        paddingBottom: "20px"
      }}
    >
      <h2>Save your precious time with Reusable Steps</h2>
      <div
        className="upgrade-content"
        style={{
          marginTop: "20px",
          marginBottom: "20px",
          color: "#6f6f6f"
        }}
      >
        Upgrade to Premium to reuse test case steps your team use often so that
        your team doesn't have to do boring repetitive typing!
      </div>
      <Link to="/upgrade_plan">
        <Button
          type="primary"
          size="large"
          className="btn-success"
          style={{ paddingLeft: "20px", marginTop: "20px" }}
        >
          {" "}
          Upgrade now{" "}
          <Icon
            type="star"
            theme="filled"
            style={{
              color: "#f9d00a",
              marginTop: "2px",
              verticalAlign: "middle",
              fontSize: "14px"
            }}
          />
        </Button>
      </Link>
      <div>
        <a
          href={"/select_plan/trial/5"}
          style={{
            color: "#00ca72",
            display: "block",
            marginTop: "10px"
          }}
        >
          Try for free
        </a>
      </div>
    </div>
  );
}
export default hot(module)(ReusableStepPromo);
